/**
 * The alternative designs that components can use
 */
export const Design = {
  STANDARD: 'standard' as const,
  SMALL: 'small' as const,
  LARGE: 'tertiary' as const,
  TEXT: 'text' as const,
};

export type Design = (typeof Design)[keyof typeof Design];
